/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ today: NonNullable<unknown>, overdue: NonNullable<unknown> }} Dashboard_Agenda_CountsInputs */

const cs_dashboard_agenda_counts = /** @type {(inputs: Dashboard_Agenda_CountsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.today} dnes · ${i?.overdue} po termínu`)
};

const en_dashboard_agenda_counts = /** @type {(inputs: Dashboard_Agenda_CountsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.today} today · ${i?.overdue} overdue`)
};

/**
* | output |
* | --- |
* | "{today} today · {overdue} overdue" |
*
* @param {Dashboard_Agenda_CountsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const dashboard_agenda_counts = /** @type {((inputs: Dashboard_Agenda_CountsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Agenda_CountsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard_agenda_counts(inputs)
	return cs_dashboard_agenda_counts(inputs)
});